import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Bullet = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path fill={color} d="M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16Z" />
    </StarryUIIcon>
);
